export default __webpack_public_path__ + "static/media/import-export.e610c6b6.svg";